import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-slate-800 text-white pt-10 pb-6 mt-auto">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
                <div className="text-center md:text-left">
                    <h2 className="text-xl font-bold text-white tracking-wide">HEBIPEDIA</h2>
                    <p className="text-slate-400 mt-2 text-sm">
                        Himpunan Ekonomi Bisnis Pesantren
                    </p>
                </div>
                <div className="text-center md:text-right text-sm text-slate-400">
                    <p>&copy; {new Date().getFullYear()} HEBITREN. Hak Cipta Dilindungi.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;